import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import { forwardRef } from 'react';
import classNames from 'classnames';
import noop from 'lodash/fp/noop';
import Popover, { PLACEMENT_MAP } from '../popover/Popover';
const DEFAULT_PLACEMENT = PLACEMENT_MAP.BOTTOM;
const DEFAULT_WIDTH = 250;
const ActionBarOverlay = forwardRef((props, ref) => {
    const { children, show, preRender, id, title, onClick = noop, width = DEFAULT_WIDTH, style = {}, className, placement = DEFAULT_PLACEMENT } = props, remainingProps = __rest(props, ["children", "show", "preRender", "id", "title", "onClick", "width", "style", "className", "placement"]);
    const adjustedStyles = Object.assign(Object.assign({}, style), { width });
    const adjustedClassName = preRender && !show ? classNames(className, 'position-offscreen') : className;
    const popoverTitleClasses = classNames('ActionBarItemPopover text-color-dark', className);
    const popoverContentClasses = classNames('ActionBarItemPopover', className);
    return (_jsxs(Popover, Object.assign({ ref: ref, id: id, onClick: onClick, placement: placement }, remainingProps, { style: adjustedStyles, className: adjustedClassName }, { children: [title && _jsx(Popover.Title, Object.assign({ className: popoverTitleClasses }, { children: title })), _jsx(Popover.Content, Object.assign({ className: popoverContentClasses }, { children: children }))] })));
});
export default ActionBarOverlay;
